import React from "react";
import { ToolTip } from "@components/atoms/tooltip/tooltip";
import { LogoutIconButton } from "@components/atoms/logout-icon-button/logout-icon-button";
import { useI18N } from "@src/language/language-context";

interface LogoutIconButtonPropTypes {
  handleClick: () => void;
}

export const LogoutIconButtonWrapperWithTooltip = ({
  handleClick,
}: LogoutIconButtonPropTypes) => {
  const i18n = useI18N();

  const texts = {
    logoutButton: i18n("modules.navigation.logoutButton"),
  };

  return (
    <ToolTip position={"bottom"} content={texts.logoutButton}>
      <LogoutIconButton
        handleClick={handleClick}
        isIconActive={false}
        iconName={"logout"}
      />
    </ToolTip>
  );
};
